export const EMPTY_CELL = '';
export const MINIMAL_LOADER_HEIGHT = 120;
export const SORT_VALUES = {
    ASCEND: 'asc',
    DESCEND: 'desc',
};
//# sourceMappingURL=constants.js.map